import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveHubForPath } from './hubAccess';

type Props = {
  path?: string;
};

const HubBackButton = ({ path }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const hub = resolveHubForPath(path || pathname);
  if (!hub) return null;

  return (
    <Button
      size="small"
      color="inherit"
      startIcon={<ArrowBack />}
      onClick={() => navigate(hub.path)}
      sx={{
        alignSelf: 'flex-start',
        textTransform: 'none',
        fontWeight: 700,
        px: 0.5,
        minWidth: 0,
        color: 'text.secondary',
        '&:hover': { color: 'text.primary', bgcolor: 'transparent' },
      }}
    >
      {t('common:hubs.backTo', { hub: t(hub.titleKey) })}
    </Button>
  );
};

export default HubBackButton;
